module.exports = require('./dist/InfiniteScroll')



//////////////////
// WEBPACK FOOTER
// ../~/react-infinite-scroller/index.js
// module id = 2813
// module chunks = 1